type FilteredArray<T extends any[]> = T extends (infer U | undefined | null)[] ? U[] : T;

export function filterNullishFromArray<T extends any[]>(values: T): FilteredArray<T> {
    return values.filter((i) => i !== undefined && i !== null) as FilteredArray<T>;
}
